import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Portlet, Form, Col, Row, Button } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { AdminContext } from 'contexts/AdminContext'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [{ name: 'Libros Electronicos' }, { name: 'Caja Bancos' }]

const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const CajaBancosPage = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      __zariContext.loader.open('Descargando libro de caja - bancos')

      AsientoContableService.descargarLibroElectronicoCajaBancos(data)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )

  return (
    <Portlet>
      <Portlet.Header title='Libros Electronicos' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        <Row>
          <Col md={4}>
            <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
              {({ errors, touched, isSubmitting, handleSubmit }) => (
                <Form>
                  <FormGroups.MesContabilidadFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.mes}
                    iTouched={touched.mes}
                  />
                  <Row>
                    <Col md={12} className='text-right'>
                      <Button outline disabled={isSubmitting} onClick={handleSubmit}>
                        Descargar
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(CajaBancosPage)
